import http from "@/services/configService";

export default {

    salvarCliente: async (cliente) => {
        return await http.post('/clientes', cliente)
    }
}  
